import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { toNumber } from 'lodash';
import { lastValueFrom, map } from 'rxjs';
import { InvoiceDatesInfo, ManualInvoicing } from 'src/app/administration/pages/manual-invoicing/manual-invoicing-model';
@Injectable({
  providedIn: 'root'
})
export class ManualInvoicingApiService {
  constructor(private apollo: Apollo) { }

  verify(input: ManualInvoicing[]): Promise<any> {

    let payload = input.map((item) => {
      return {
        chassisNumber: item.chassisNumber,
        countryCode: item.countryCode,
        invoiceAmount: toNumber(item.invoiceAmount),
        responsibilityCode: item.responsibilityCode,
        invoiceDate: item.invoiceDate ? new Date(item.invoiceDate).toISOString() : null
      }
    })

    const mutation = `
        mutation ($payload: [ManualInvoicingInput]!) {
            manualInvoicing {
              verify(payload: $payload){
                chassisNumber
                serialNumber
                countryCode
                invoiceAmount
                invoiceDate
                responsibilityCode
              }
          }
        }`;

    return this.apollo.mutate({
      mutation: gql(mutation),
      variables: { payload }
    }).toPromise();
  }

  async confirm(input: ManualInvoicing[]): Promise<any> {

    let payload = input.map((item) => {
      return {
        chassisNumber: item.chassisNumber,
        countryCode: item.countryCode,
        invoiceAmount: toNumber(item.invoiceAmount),
        responsibilityCode: item.responsibilityCode,
        invoiceDate: item.invoiceDate ? new Date(item.invoiceDate).toISOString() : null
      }
    })

    const mutation = `
        mutation ($payload: [ManualInvoicingInput]!) {
            manualInvoicing {
              confirm(payload: $payload)
          }
        }`;

    return this.apollo.mutate({
      mutation: gql(mutation),
      variables: { payload }
    }).toPromise();
  }

  async getInvoiceDatesInfo(variables?): Promise<any> {
    let payload = variables.map((item) => {
      return {
        chassisNumber: item.chassisNumber,
        countryCode: item.countryCode,
        invoiceAmount: toNumber(item.invoiceAmount),
        responsibilityCode: item.responsibilityCode,
        invoiceDate: item.invoiceDate ? new Date(item.invoiceDate).toISOString() : null
      }
    })
    const result$ = this.apollo
      .query<InvoiceDatesInfo[]>({
        variables: { payload },
        fetchPolicy: "no-cache",
        query: gql`
                  query invoiceIndividualQuery($payload: [ManualInvoicingInput]!) {
                      removedInvoiceDatesList {
                          invoiceDatesInfo(payload: $payload) {
                              invoiceDate
                              fileName
                              chassisNumber
                              serialNumber
                          }
                      }
                  }
              `,
      })
      
      .pipe(
        map((result: any) => {
          const rawData = result?.data?.removedInvoiceDatesList?.invoiceDatesInfo ?? [];
          if (rawData?.length) {
            const groupedMap = rawData.reduce((map, item) => {
              const { chassisNumber, serialNumber, invoiceDate, fileName } = item;

              function filterChassisAndSerialNumber(key: string, idType: 'chassis' | 'serial') {
                if (!map.has(key)) {
                  map.set(key, {
                    chassisNumber: idType === 'chassis' ? chassisNumber : null,
                    serialNumber: idType === 'serial' ? serialNumber : null,
                    previousInvoiceDatesInfo: [],
                  });
                }
                map.get(key)!.previousInvoiceDatesInfo.push({ invoiceDate, fileName });
              }

              if (chassisNumber) {
                filterChassisAndSerialNumber(`chassis-${chassisNumber}`, 'chassis');
              }

              if (serialNumber) {
                filterChassisAndSerialNumber(`serial-${serialNumber}`, 'serial');
              }

              return map;
            }, new Map<string, InvoiceDatesInfo>());

            return Array.from(groupedMap.values());

          }
          else {
            return [];
          }
        })
      );
    return lastValueFrom(result$);
  }
}